import { 
  Container, 
  Typography, 
  Box, 
  Paper, 
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FONT_FAMILY, FONT_HEADING } from '../Tree/constants/theme';

export default function TalkTreeResources() {
  return (
    <Container maxWidth="lg" sx={{ py: 4, fontFamily: FONT_FAMILY }}>
      {/* Main Heading */}
      <Typography 
        variant="h1" 
        component="h1" 
        gutterBottom 
        sx={{ 
          fontWeight: 600, 
          fontSize: '1.5rem',
          mb: 4, 
          textAlign: 'left' 
        }}
      >
        Get Started by Watching These Videos
      </Typography>

      {/* Video 1 */}
      <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
        <Typography 
          variant="h2" 
          component="h2" 
          gutterBottom 
          sx={{ 
            fontWeight: 600, 
            fontSize: '1.25rem',
              
            mb: 3, 
            textAlign: 'left' 
          }}
        >
          What are Talk Trees?
        </Typography>
        
        <Box 
          sx={{ 
            position: 'relative',
            paddingBottom: '56.25%', 
            height: 0,
            overflow: 'hidden',
            borderRadius: 1,
            backgroundColor: '#f5f5f5',
            mb: 2
          }}
        >
          <iframe
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 'none',
              borderRadius: '4px'
            }}
            src="https://drive.google.com/file/d/1WFMwv2kw77JZ0FiVERX70cTzg2JAJLLD/preview"
            title="What is a Talk Tree?"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </Box>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="video1-content"
            id="video1-header"
          >
            <Typography 
              variant="body1" 
              sx={{ 
                fontWeight: 600, 
                fontSize: '1rem',
                  
              }}
            >
              Summary
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 3, mt: 0, textAlign: 'left' }}>
              <Typography 
                component="li" 
                variant="body1" 
                sx={{ 
                  mb: 2, 
                  fontSize: '1rem', 
                  fontWeight: 400,
                    
                }}
              >
                The video briefly explains what a Talk Tree is: A visualization of student dialogue in a class session.
              </Typography>
              <Typography 
                component="li" 
                variant="body1" 
                sx={{ 
                  mb: 2, 
                  fontSize: '1rem', 
                  fontWeight: 400,
                    
                }}
              >
                This video also explores what makes Talk Trees special including their student-centered attention to dialogue, ability to reimagine teacher learning, and their use of AI to celebrate, not evaluate student talk.
              </Typography>
              <Typography 
                component="li" 
                variant="body1" 
                sx={{ 
                  mb: 2, 
                  fontSize: '1rem', 
                  fontWeight: 400,
                    
                }}
              >
                This video shares teacher insights on Talk Trees and their influence on student conversations in class, namely that students felt "more ownership" in their class discussions.
              </Typography>
            </Box>
          </AccordionDetails>
        </Accordion>
      </Paper>

      {/* Video 2 */}
      <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
        <Typography 
          variant="h2" 
          component="h2" 
          gutterBottom 
          sx={{ 
            fontWeight: 600, 
            fontSize: '1.25rem',
              
            mb: 3, 
            textAlign: 'left'
          }}
        >
          Why Talk?
        </Typography>
        
        <Box 
          sx={{ 
            position: 'relative',
            paddingBottom: '56.25%', 
            height: 0,
            overflow: 'hidden',
            borderRadius: 1,
            backgroundColor: '#f5f5f5',
            mb: 2
          }}
        >
          <iframe
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 'none',
              borderRadius: '4px'
            }}
            src="https://drive.google.com/file/d/1kWQGpNEW2dElDlZrF5xEBwAlr4Tl61jS/preview"
            title="Examples of Talk Trees"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </Box>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="video2-content"
            id="video2-header"
          >
            <Typography 
              variant="body1" 
              sx={{ 
                fontWeight: 600, 
                fontSize: '1rem',
                  
              }}
            >
              Summary
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 3, mt: 0, textAlign: 'left' }}>
              <Typography 
                component="li" 
                variant="body1" 
                sx={{ 
                  mb: 2, 
                  fontSize: '1rem', 
                  fontWeight: 400,
                    
                }}
              >
                This video explains how and why Talk Trees leverage the Academically Productive Talk Framework to highlight and generate more impactful student-centered class discussions.
              </Typography>
              <Typography 
                component="li" 
                variant="body1" 
                sx={{ 
                  mb: 2, 
                  fontSize: '1rem', 
                  fontWeight: 400,
                    
                }}
              >
                This video explains each component of a Talk Tree -- red, blue, and yellow flowers and leaves -- and gives student talk examples of each.
              </Typography>
            </Box>
          </AccordionDetails>
        </Accordion>
      </Paper>

      {/* Video 3 */}
      <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
        <Typography 
          variant="h2" 
          component="h2" 
          gutterBottom 
          sx={{ 
            fontWeight: 600, 
            fontSize: '1.25rem',
              
            mb: 3, 
            textAlign: 'left' 
          }}
        >
          How to use the Talk Trees application?
        </Typography>
        
        <Box 
          sx={{ 
            position: 'relative',
            paddingBottom: '56.25%',
            height: 0,
            overflow: 'hidden',
            borderRadius: 1,
            backgroundColor: '#f5f5f5',
            mb: 2
          }}
        >
          <iframe
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 'none',
              borderRadius: '4px'
            }}
            src="https://drive.google.com/file/d/1-7A1qhb64TDPme6ydyFPPG4a7a6xTO8M/preview"
            title="What Can I Do with Talk Trees?"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </Box>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="video3-content"
            id="video3-header"
          >
            <Typography 
              variant="body1" 
              sx={{ 
                fontWeight: 600, 
                fontSize: '1rem',
                  
              }}
            >
              Summary
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 3, mt: 0, textAlign: 'left' }}>
              <Typography 
                component="li" 
                variant="body1" 
                sx={{ 
                  mb: 2, 
                  fontSize: '1rem', 
                  fontWeight: 400,
                    
                }}
              >
                This video walks through the Talk Trees interface, explaining each section of the platform including: where to access more resources, how to select a specific tree to explore, and what you can do with students using the Talk Trees.              </Typography>
              <Typography 
                component="li" 
                variant="body1" 
                sx={{ 
                  mb: 2, 
                  fontSize: '1rem', 
                  fontWeight: 400,
                    
                }}
              >
                This video also explores what an overview of a Talk Tree entails from a session summary to if/when a Tree fills up.
              </Typography>
              <Typography 
                component="li" 
                variant="body1" 
                sx={{ 
                  mb: 2, 
                  fontSize: '1rem', 
                  fontWeight: 400,
                    
                }}
              >
                The video expands on what activities teachers can do with students using conversational scaffolds for introducing a tree, celebrating, or comparing Talk Trees. This video also highlights how to generate presentations of the Trees with the scaffolds to use with students.
              </Typography>
            </Box>
          </AccordionDetails>
        </Accordion>
      </Paper>

      {/* Video 4 */}
      <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
        <Typography 
          variant="h2" 
          component="h2" 
          gutterBottom 
          sx={{ 
            fontWeight: 600, 
            fontSize: '1.25rem',
              
            mb: 3, 
            textAlign: 'left' 
          }}
        >
          What is Explore My Talk?
        </Typography>
        
        <Box 
          sx={{ 
            position: 'relative',
            paddingTop: '56.25%', // 16:9 aspect ratio
            height: 0,
            overflow: 'hidden',
            borderRadius: 1,
            backgroundColor: '#f5f5f5',
            mb: 2
          }}
        >
          <iframe
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 'none',
              borderRadius: '4px'
            }}
            src="https://drive.google.com/file/d/1jpCD24Buc3QAmSQ1Y-Is2teXVQ2e7Smp/preview"
            title="What is Explore My Talk?"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </Box>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="video4-content"
            id="video4-header"
          >
            <Typography 
              variant="body1" 
              sx={{ 
                fontWeight: 600, 
                fontSize: '1rem',
                  
              }}
            >
              Summary
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 3, mt: 0, textAlign: 'left' }}>
              <Typography 
                component="li" 
                variant="body1" 
                sx={{ 
                  mb: 2, 
                  fontSize: '1rem', 
                  fontWeight: 400,
                    
                }}
              >
                This video explains that rather than focus on student talk, the Explore My Talk feature on the Talk Trees interface highlights educator talk.
              </Typography>
              <Typography 
                component="li" 
                variant="body1" 
                sx={{ 
                  mb: 2, 
                  fontSize: '1rem', 
                  fontWeight: 400,
                    
                }}
              >
                This video explores what you will see when using Explore My Talk, including excerpted transcripts of educator talk and AI feedback.
              </Typography>
              <Typography 
                component="li" 
                variant="body1" 
                sx={{ 
                  mb: 2, 
                  fontSize: '1rem', 
                  fontWeight: 400,
                    
                }}
              >
                This video elaborates how the Explore My Talk feature displays up to six randomly selected examples of educator talk and sorts them into strengths and opportunities.
              </Typography>
            </Box>
          </AccordionDetails>
        </Accordion>
      </Paper>
    </Container>
  );
}